<template>
  <div class="w-full lg:w-3/4 pb-10">
    <section>
      <h3 class="text-gray-700 font-medium">
        In Progress ({{ inProgressApplications.length }})
      </h3>
      <div class="mt-4 application_cards_grid">
        <application-card
          v-for="application in inProgressApplications"
          :key="application.id"
          :application="application"
        >
        </application-card>
      </div>
    </section>
    <section class="mt-10" v-if="completedApplications.length">
      <h3 class="text-gray-700 font-medium">
        Completed ({{ completedApplications.length }})
      </h3>
      <div class="mt-4 application_cards_grid">
        <application-card
          v-for="application in completedApplications"
          :key="application.id"
          :application="application"
        >
        </application-card>
      </div>
    </section>
    <NoRecords v-if="!applications.length">
      It seems you don't have any applications yet.
    </NoRecords>
    <ag-document-checklist-drawer
      ref="documentsChecklist"
      v-if="showDrawer"
      :application="application_in_drawer"
      @close="closeDrawer"
    />
    <upload-documents-modal
      v-if="showModal"
      @uploadDocumentsComplete="handleUploadComplete"
      @close="closeDocumentUploadModal"
      :documentId="documentToUpload.id"
      :documentName="documentToUpload.document_type_name"
      :dueSoon="isDueSoon(documentToUpload.due_date)"
    />
  </div>
</template>

<script>
import axios from 'axios';
import NoRecords from '@/components/NoRecords.vue';
import ApplicationCard from './components/ApplicationCard';
import STATUS from './applicationStatus';
import AgDocumentChecklistDrawer from './components/AgDocumentChecklistDrawer';
import EventBus from './EventBus';
import UploadDocumentsModal from '@/components/UploadDocumentModal';
import moment from 'moment';

export default {
  name: 'ApplicationList',
  components: {
    NoRecords,
    ApplicationCard,
    AgDocumentChecklistDrawer,
    UploadDocumentsModal
  },
  async beforeRouteEnter(to, from, next) {
    let response = await axios.get('/api/applications');
    next(vm => {
      vm.applications = response.data;
    });
  },
  data() {
    return {
      applications: [],
      showDrawer: false,
      showModal: false,
      application_in_drawer: null,
      documentToUpload: null
    };
  },
  created() {
    EventBus.$on('SHOW_DOCUMENT_CHECKLIST_DRAWER', application => {
      this.application_in_drawer = application;
      this.openDrawer();
    });
    EventBus.$on('upload:document', document => {
      this.documentToUpload = document;
      this.swapToModal();
    });
  },
  computed: {
    inProgressApplications() {
      return this.applications.filter(application => {
        return application.status.id === STATUS.OPEN;
      });
    },
    completedApplications() {
      return this.applications.filter(
        application => application.status.id === STATUS.COMPLETE
      );
    }
  },
  methods: {
    getInProgressCount() {
      return 0;
    },
    openDrawer() {
      this.showDrawer = true;
    },
    closeDrawer() {
      this.showDrawer = false;
    },
    closeDocumentUploadModal() {
      this.documentToUpload = null;
      this.swapToDrawer();
    },
    handleUploadComplete() {
      this.$toasted.success('Your document has been uploaded sucessfully');
      this.documentToUpload = null;
      this.swapToDrawer();
    },
    swapToDrawer() {
      this.showDrawer = true;
      this.showModal = false;
    },
    swapToModal() {
      this.showDrawer = false;
      this.showModal = true;
    },
    isDueSoon(due_date) {
      if (!due_date) {
        return false;
      }

      const due_date_moment = moment(due_date.date);
      const today = moment();
      const diff = due_date_moment.diff(today, 'days');
      if (diff < 7 && diff >= 0) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.application_cards_grid {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(1, 1fr);
}

@media only screen and (min-width: 768px) {
  .application_cards_grid {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
